import {UseQueryResult} from "@tanstack/react-query";
import {createContext, useContext} from "react";
import {RetailOrderContextType} from "../types/RetailOrderContextType";
import {RetailOrderDetails} from "../types/RetailOrderDetails";

enum RefetchScope {
	Files,
	Notes
}

const RetailOrderContext = createContext<{	
	order: RetailOrderContextType, 
	modifyOrder: (details: RetailOrderDetails) => void
	refetchOrder: (scope?: RefetchScope) => Promise<UseQueryResult>
}>
({ 
	order: {} as RetailOrderContextType,
	modifyOrder: () => {},
	refetchOrder: (scope?: RefetchScope) => { return new Promise(() => {}); }
});

const useRetailOrder = () => useContext(RetailOrderContext);

export {RetailOrderContext, useRetailOrder, RefetchScope}
